export default __webpack_public_path__ + "static/media/bootstrap.527d0fc0.svg";